module.exports = __webpack_public_path__ + "static/media/moon_green-min.f5211d45.png";